import { storeConstants } from './constants';

const isStoreOutDated = (timestamp, refreshTime = storeConstants.REFRESH_TIME) => {
    let now = new Date().getTime();

    if (now - timestamp > refreshTime) {
        return true;
    }
    return false;
};

export default {
    isStoreOutDated,
};
